<ng-template #crudActionsTemplateRef>
    <div class="crud-buttons w-100">
        <div class="dropdown float-start">
            <button class="px-3 py-1 border shadow-sm btn btn-sm bg-light dropdown-toggle rounded-pill" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              Actions
            </button>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" role="button" data-bs-toggle="modal" data-bs-target="#add-new-user-modal" (click)="addNewUserBasicDetailsFormFields = fieldsService?.getFormFields(addNewUserBasicDetailsFormModel ?? {}, {appName: appName, domain: helperService?.filterData(applicationDomains, 'id', domainId)?.domainName }); addNewUserPasswordFormFields = fieldsService?.getFormFields(addNewUserPasswordFormModel)">
                    <span class="mdi mdi-plus-circle text-success"></span>
                    <span class="ms-2">New User</span>
                </a>
              </li>
              <li>
                <a class="dropdown-item" role="button" data-bs-toggle="modal" data-bs-target="#bulk-add-users-modal" (click)="addNewUserBasicDetailsFormFields = fieldsService?.getFormFields(addNewUserBasicDetailsFormModel ?? {}, {appName: appName, domain: helperService?.filterData(applicationDomains, 'id', domainId)?.domainName }); addNewUserPasswordFormFields = fieldsService?.getFormFields(addNewUserPasswordFormModel)">
                    <span class="mdi mdi-folder-plus text-success"></span>
                    <span class="ms-2">Bulk Add Users</span>
                </a>
              </li>
              <ng-container *ngIf="flow === 'domain' && checkCreateDomainResourceRole()">
                <li>
                    <a class="dropdown-item" role="button" data-bs-toggle="modal" data-bs-target="#add-domain-resource-modal" (click)="addDomainResourceFormFields = fieldsService?.getFormFields(addDomainResourceFormModel ?? {}); getApplicationResources(true);">
                        <span class="mdi mdi-plus-circle text-success"></span>
                        <span class="ms-2">Domain Resource</span>
                    </a>
                  </li>
              </ng-container>
              <ng-container *ngIf="flow === 'admin'">
                <li>
                    <a class="dropdown-item" role="button" data-bs-placement="auto" data-bs-toggle="modal" data-bs-target="#bulk-user-deletion-modal">
                        <span class="mdi mdi-delete-variant text-danger"></span>
                        <span class="ms-2">Bulk User Deletion</span>
                    </a>
                  </li>
              </ng-container>
              <li>
                <a class="dropdown-item" role="button" data-bs-toggle="modal" data-bs-target="#bulk-add-users-roles-modal" data-bs-placement="right">
                    <span class="mdi mdi-cloud-upload text-primary-dark"></span>
                    <span class="ms-2">Bulk Add Roles</span>
                </a>
              </li>
              <a class="dropdown-item" role="button" (click)="downloadUserDetailsReport();">
                <span class="mdi mdi-download text-accent"></span>
                <span class="ms-2">User Details Report</span>
            </a>
            </ul>
        </div>
        <ng-container *ngIf="flow === 'domain' && (authService?.currentUser)?.roles?.includes('app.settings.admin')">
            <button type="button" appButton class="border-0 btn btn-sm btn-outline-primary rounded-circle ms-2 float-end" title="Change Domain Settings" data-bs-placement="auto" data-bs-toggle="offcanvas" data-bs-target="#domain-settings-modal" (click)="setDomainSettingsValue();">
                <span class="mdi mdi-cog mdi-18px"></span>
            </button>
        </ng-container>
    </div>
</ng-template>

<div class="row">
    <div class="mt-4 col-12">
        <div class="border-0 shadow-sm card">
            <div class="mb-2 row">
                <div class="col-auto text-center text-white rounded bg-orange card-icon rounded-pill d-flex align-items-center justify-content-center">
                    <i class="mb-0 mdi mdi-account-multiple h4"></i>
                    <span class="mb-0 h5 fw-normal d-none d-sm-inline ms-2">Users</span>
                </div>
            </div>
            <div class="bg-white border-0 shadow-sm card-header position-sticky sticky-top">
                <div class="row {{flow === 'admin' ? '' : 'mt-2'}} align-items-center">

                    <ng-container *ngIf="flow === 'admin'">
                        <div class="col-12 col-sm-auto form-group form-label-group ps-3">
                            <custom-select class="form-group form-label-group" [field]="(applicationSelect)" [clearable]="false" [multiSelect]="false" [pristine]="true" (selectedArrayEvent)="appName = $event?.[0]; userService?.setAppDataInStorage(appName, -1); getApplicationDomains(appName); getUserRoles(); users = []; textSearchSpy.value = '';"> </custom-select>
                        </div>
                        <div class="col-12 col-sm-auto form-group form-label-group pe-3">
                            <custom-select class="form-group form-label-group" [field]="(applicationDomainSelect)" [clearable]="false" [multiSelect]="false" [pristine]="true" (selectedArrayEvent)="domainId = $event?.[0]; userService?.setAppDataInStorage(appName, domainId); getUsers(); textSearchSpy.value = '';"> </custom-select>
                        </div>
                    </ng-container>

                    <div class="mb-2 col mb-sm-0">
                        <div class="my-auto btn-group btn-group-sm px-sm-0 mb-md-3" role="group">
                            <ng-container *ngFor="let userStatus of userStatusList">
                                <input type="radio" class="btn-check" id="{{userStatus}}-user-status" name="userStatus" [value]="userStatus" [(ngModel)]="selectedUserStatus" (change)="selectedUserStatus === 'admin' ? getUsersForAdminTab() : getUsers(); textSearchSpy.value = '';" required >
                                <label class="shadow-sm btn btn-light text-nowrap" for="{{userStatus}}-user-status"> {{userStatus | titlecase}} Users </label>
                            </ng-container>
                        </div>
                    </div>

                    <div class="col-auto ms-sm-auto">
                        <div class="mt-0 form-label-group">
                          <input type="text" placeholder="Enter user details" class="form-control form-control-sm" id="text-search" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}" (keyup)="searchData(textSearchSpy?.value)" #textSearchSpy />
                          <label class="pb-3" for="text-search">Search</label>
                        </div>
                    </div>

                </div>

                <div class="row justify-content-between" *ngIf="false">
                    <div class="my-auto btn-group btn-group-sm col-12 col-sm-auto px-sm-0 ms-sm-3 mb-md-3" role="group">
                        <ng-container *ngFor="let userStatus of userStatusList">
                            <input type="radio" class="btn-check" id="{{userStatus}}-user-status" name="userStatus" [value]="userStatus" [(ngModel)]="selectedUserStatus" (change)="selectedUserStatus === 'admin' ? getUsersForAdminTab() : getUsers(selectedUserStatus); textSearchSpy.value = '';" required >
                            <label class="shadow-sm btn btn-light" for="{{userStatus}}-user-status"> {{userStatus | titlecase}} Users </label>
                        </ng-container>
                    </div>
                    <div class="col-12 col-sm-auto d-flex align-items-center justify-content-end ms-n1">
                        <div class="mt-0 form-label-group ps-2">
                          <input type="text" placeholder="Enter user details" class="form-control form-control-sm" id="text-search" (keyup)="searchData(textSearchSpy?.value)" #textSearchSpy />
                          <label class="pb-3" for="text-search">Search</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <com-pagination [results]="users" [filterColumns]="['appName','fullName','description','url']" (dataEmitter)="paginationHandler($event);" *ngIf="!textSearchSpy?.value"></com-pagination>
                    </div>
                </div>

            </div>
            <div class="card-body overflow-md-auto">
                <div class="row">
                    <div class="col-12">
                        <table class="table table-hover">
                            <thead>
                                <tr class="bg-white position-sticky shadow-sm table-header-{{flow}}">
                                    <th class="text-center toggle-switch-width">Enabled</th>
                                    <!-- <th class="text-center toggle-switch-width">Verification</th> -->
                                    <th class="col">Full Name</th>
                                    <th class="col">Username</th>
                                    <th class="w-50">Roles</th>
                                    <th class="text-center actions-col-width">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngIf="users?.length">
                                  <tr class="user-row" *ngFor="let user of textSearchSpy?.value ? searchResults : users?.slice((paginationParams?.pageNo-1)*paginationParams?.pageSize, paginationParams?.pageNo*paginationParams?.pageSize); let i = index;">
                                      <td class="text-center">
                                          <label class="switch" for="user-enabled-for-{{user?.id}}">
                                              <input type="checkbox" name="check" id="user-enabled-for-{{user?.id}}" [checked]="user?.enabled" (change)="selectedUser = user; selectedUser['index'] = i; changeUserStateModalDataModification(switchSpy);" data-bs-toggle="modal" attr.data-bs-target="#{{ (flow === 'domain' && selectedUserStatus === 'system') ? '' : user?.enabled ? 'disable' : 'enable'}}-user-state-modal" data-bs-placement="auto" title="{{user?.enabled ? 'Disable' : 'Enable'}} User" [disabled]="flow === 'domain' && selectedUserStatus === 'system'" #switchSpy>
                                              <span class="ball"></span>
                                          </label>
                                      </td>
                                      <td>
                                        <div>
                                          <a class="text-decoration-none text-nowrap pointer" data-bs-toggle="modal" data-bs-target="#role-management-modal" (click)="$event.preventDefault(); selectedUser = user; selectedUser['index'] = i;">
                                            <span>{{user?.fullName || user?.fullname || '-'}}</span>
                                            <span class="mdi ms-1" [ngClass]="user?.verificationStatus === 'VERIFIED' ? 'mdi-check-decagram text-primary-dark' : (user?.verificationStatus === 'VERIFICATION_REQUIRED' ? 'mdi-shield-alert text-danger' : 'mdi-shield-sync text-warning')" title="{{user?.verificationStatus === 'VERIFIED' ? 'User Verified' : (user?.verificationStatus === 'VERIFICATION_REQUIRED' ? 'User not verified but verification will be required during next sign-in' : 'Verification not required')}}" data-bs-placement="auto"></span>
                                        </a>
                                        </div>
                                      </td>
                                      <!-- <td class="small" title="{{user?.username}}" data-bs-placement="auto">
                                        {{user?.username || '-' | ellipsis: 10}}
                                      </td> -->
                                      <td class="small">
                                        <p class="mb-0 text-wrap">{{user?.username || '-'}}</p>
                                        <p class="mb-0 text-muted text-wrap">{{user?.email || '-'}}</p>
                                      </td>
                                      <td>
                                          <span *ngIf="!user?.roles?.length" else #rolesPillDiv>-</span>
                                          <com-view-roles [flow]="flow" [user]="user" [domainResourceMap]="domainResourceMap" [userRolesMap]="userRolesMap" *ngIf="isDomainResourcesLoaded && isUserRolesLoaded"></com-view-roles>
                                      </td>
                                      <td>
                                          <div class="user-row-action-buttons d-flex justify-content-center">
                                              <button type="button" appButton class="px-2 py-1 border-0 btn btn-outline-primary rounded-circle me-1" title="Update User Details" data-bs-placement="auto" data-bs-toggle="modal" data-bs-target="#update-user-details-modal" (click)="selectedUser = user; selectedUser['index'] = i; updateUserDetailsFormFields = fieldsService?.getFormFields(updateUserDetailsFormModel ?? {}, selectedUser || {});">
                                                  <span class="mdi mdi-pencil"></span>
                                              </button>
                                              <button type="button" appButton class="px-2 py-1 border-0 btn btn-outline-accent rounded-circle me-1" title="Manage User Login Mode" data-bs-placement="auto" data-bs-toggle="modal" data-bs-target="#manage-user-login-mode-modal" (click)="selectedUser = user; selectedUser['index'] = i; manageUserLoginModeModalConfig['pillData'] = user?.fullName; manageUserLoginModeFormFields = fieldsService?.getFormFields(manageUserLoginModeFormModel ?? {}, selectedUser || {});">
                                                <span class="mdi mdi-account-cog"></span>
                                              </button>
                                              <button type="button" appButton class="px-2 py-1 border-0 btn btn-outline-danger rounded-circle me-1" title="Change User Password" data-bs-placement="auto" data-bs-toggle="modal" data-bs-target="#change-user-password-modal" (click)="selectedUser = user; selectedUser['index'] = i; changeUserPasswordModalConfig['pillData'] = app?.fullName; changeUserPasswordFormFields = fieldsService?.getFormFields(changeUserPasswordFormModel ?? {}, selectedUser || {});">
                                                  <span class="mdi mdi-lock-open"></span>
                                              </button>
                                              <button type="button" appButton class="px-2 py-1 border-0 btn btn-outline-teal rounded-circle me-1" title="Reset User" data-bs-placement="auto" data-bs-toggle="modal" data-bs-target="#reset-user-modal" (click)="selectedUser = user; selectedUser['index'] = i; resetUserModalConfig['pillData'] = user?.fullName;">
                                                <span class="mdi mdi-backup-restore"></span>
                                              </button>
                                              <ng-container *ngIf="flow === 'admin' && user?.authMode === 'basic'">
                                                <ng-container *ngIf="!this.selectedApplicationDomain?.verificationRequired">
                                                    <label class="my-auto switch user-verification-switch ms-n2" for="user-email-verification-for-{{user?.id}}">
                                                        <input type="checkbox" name="user-email-verification-switch-for-{{user?.id}}" id="user-email-verification-for-{{user?.id}}" [checked]="user?.verificationStatus !== 'NOT_VERIFIED'" (change)="$event.stopImmediatePropagation(); selectedUser = user; selectedUser['index'] = i; changeUserVerificationStatusDataModification(userVerificationStatusSwitchSpy, user?.verificationStatus);" data-bs-toggle="modal" attr.data-bs-target="#{{user?.authMode === 'basic' ? (user?.verificationStatus === 'NOT_VERIFIED' ? 'enable-user-verification-status-modal' : (user?.verificationStatus === 'VERIFICATION_REQUIRED' ? 'disable-user-verification-status-modal' : '') ) : ''}}" data-bs-placement="auto" title="{{user?.verificationStatus === 'NOT_VERIFIED' ? 'Enable Email Verification' : 'Disable Email Verification'}}" [disabled]="user?.authMode !== 'basic'" #userVerificationStatusSwitchSpy>
                                                        <span class="ball"></span>
                                                    </label>
                                                </ng-container>
                                                <ng-container *ngIf="!this.selectedApplicationDomain?.mfaVerificationRequired">
                                                    <div class="position-relative">
                                                        <p class="font-size-70 fw-semibold position-absolute ms-2 mt-n2">MFA</p>
                                                        <label class="my-auto mt-1 align-middle switch mfa-verification-switch ms-n2" for="user-mfa-verification-for-{{user?.id}}">
                                                            <input type="checkbox" name="user-mfa-verification-switch-for-{{user?.id}}" id="user-mfa-verification-for-{{user?.id}}" [checked]="!!user?.mfaRequired" [attr.disabled]="user.verificationStatus === 'NOT_VERIFIED' ? true : null" (change)="$event.stopImmediatePropagation(); selectedUser = user; selectedUser['index'] = i; changeUserMFAStatusDataModification(userMFAStatusSwitchSpy, !!user?.mfaRequired, !!this.selectedApplicationDomain?.mfaVerificationRequired);" data-bs-toggle="modal" attr.data-bs-target="#{{!user?.mfaRequired ? 'enable-user-mfa-status-modal' : 'disable-user-mfa-status-modal'}}" data-bs-placement="auto" title="{{!!!user?.mfaRequired ? 'Enable MFA' : 'Disable MFA'}}" [disabled]="user?.authMode !== 'basic'" #userMFAStatusSwitchSpy>
                                                            <span class="ball"></span>
                                                        </label>
                                                    </div>
                                                </ng-container>
                                              </ng-container>
                                              <ng-container *ngIf="flow === 'domain' && (authService?.currentUser)?.roles?.includes('app.settings.admin') && user?.authMode === 'basic'">
                                                <ng-container *ngIf="!domainDetails?.verificationRequired">
                                                    <label class="my-auto switch user-verification-switch ms-n2" for="user-email-verification-for-{{user?.id}}">
                                                        <input type="checkbox" name="user-email-verification-switch-for-{{user?.id}}" id="user-email-verification-for-{{user?.id}}" [checked]="user?.verificationStatus !== 'NOT_VERIFIED'" (change)="$event.stopImmediatePropagation(); selectedUser = user; selectedUser['index'] = i; changeUserVerificationStatusDataModification(userVerificationStatusSwitchSpy, user?.verificationStatus);" data-bs-toggle="modal" attr.data-bs-target="#{{user?.authMode === 'basic' ? (user?.verificationStatus === 'NOT_VERIFIED' ? 'enable-user-verification-status-modal' : (user?.verificationStatus === 'VERIFICATION_REQUIRED' ? 'disable-user-verification-status-modal' : '') ) : ''}}" data-bs-placement="auto" title="{{user?.verificationStatus === 'NOT_VERIFIED' ? 'Enable Email Verification' : 'Disable Email Verification'}}" [disabled]="user?.authMode !== 'basic'" #userVerificationStatusSwitchSpy>
                                                        <span class="ball"></span>
                                                    </label>
                                                </ng-container>
                                                <ng-container *ngIf="!domainDetails?.mfaVerificationRequired">
                                                    <div class="position-relative">
                                                        <p class="font-size-70 fw-semibold position-absolute ms-2 mt-n2">MFA</p>
                                                        <label class="my-auto mt-1 align-middle switch mfa-verification-switch ms-n2" for="user-mfa-verification-for-{{user?.id}}">
                                                            <input type="checkbox" name="user-mfa-verification-switch-for-{{user?.id}}" id="user-mfa-verification-for-{{user?.id}}" [checked]="!!user?.mfaRequired" [attr.disabled]="user.verificationStatus === 'NOT_VERIFIED' ? true : null" (change)="$event.stopImmediatePropagation(); selectedUser = user; selectedUser['index'] = i; changeUserMFAStatusDataModification(userMFAStatusSwitchSpy, !!user?.mfaRequired, !!domainDetails?.mfaVerificationRequired);" data-bs-toggle="modal" attr.data-bs-target="#{{!user?.mfaRequired ? 'enable-user-mfa-status-modal' : 'disable-user-mfa-status-modal'}}" data-bs-placement="auto" title="{{!!!user?.mfaRequired ? 'Enable MFA' : 'Disable MFA'}}" [disabled]="user?.authMode !== 'basic'" #userMFAStatusSwitchSpy>
                                                            <span class="ball"></span>
                                                        </label>
                                                    </div>
                                                </ng-container>
                                              </ng-container>
                                          </div>
                                      </td>
                                  </tr>
                              </ng-container>
                            </tbody>
                          </table>
                          <p class="mb-0" *ngIf="textSearchSpy?.value && !searchResults?.length">No data found</p>
                    </div>
                </div>
            </div>
        </div>
      </div>
</div>

<com-modal [config]="addDomainResourceModalConfig">
    <com-form [formFields]="addDomainResourceFormFields"></com-form>
    <div class="mx-2 mt-1 text-muted small">
        Description can be used to differentiate between numerous values.
    </div>
</com-modal>

<com-modal [config]="addNewUserModalConfig">
    <com-form [formFields]="addNewUserBasicDetailsFormFields" #addNewUserBasicDetailsFormSpy></com-form>
    <div class="row">
        <div class="px-3 py-2 col-12 col-md-6 form-group form-label-group">
            <select class="form-control form-select" name="authMode" id="authMode" ngModel [ngModelOptions]="{standalone: true}" required [disabled]="!loginModes?.length" #addNewUserLoginModeSpy (change)="addNewUserPasswordFormFields = fieldsService?.getFormFields(addNewUserLoginModeSpy?.value === 'oauth2' ? {} : addNewUserPasswordFormModel);">
                <option disabled value="" selected>Choose Login Mode</option>
                <option *ngFor="let mode of loginModes" [value]="mode?.value">{{mode?.key}}</option>
            </select>
            <label for="authMode" class="required">Login Mode</label>
        </div>
        <div class="col-12 col-sm form-label-group" *ngIf="addNewUserLoginModeSpy?.value === 'system'">
            <button type="button" appButton class="btn btn-sm btn-outline-orange" (click)="generateRandomPassword();" >Auto Generate Password</button>
        </div>
    </div>
    <com-form [formFields]="addNewUserPasswordFormFields" #addNewUserPasswordFormSpy>
    </com-form>
    <div class="mx-2 mt-1 text-muted small" *ngIf="addNewUserLoginModeSpy?.value !== 'oauth2'">
        Password should be 10-character long alphanumeric and must contain at least one of ! @ # $ & special characters
    </div>
    <div class="modal-footer" modal-footer-content>
        <button type="button" appButton class="btn btn-sm btn-teal me-2" (click)="addNewUser(addNewUserBasicDetailsFormSpy?.formObjSpy, addNewUserLoginModeSpy?.value, addNewUserPasswordFormSpy?.formObjSpy, cancelBtnSpy)" [disabled]="addNewUserBasicDetailsFormSpy?.formObjSpy?.invalid || (['basic','system']?.includes(addNewUserLoginModeSpy?.value) ? addNewUserPasswordFormSpy?.formObjSpy?.invalid : !addNewUserLoginModeSpy?.value)">
            <span>Submit</span>
        </button>
        <button type="button" appButton class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal" (click)="addNewUserLoginModeSpy.value = '';" #cancelBtnSpy>
            <span>Cancel</span>
        </button>
    </div>
</com-modal>

<com-modal [config]="bulkUserDeletionModalConfig">
    <div class="row">
        <div class="col-12">
            <label class="fw-bold required">CSV File</label>
            <div class="custom-file">
                <input class="form-control" name="file" type="file" id="user-csv" accept=".csv" required ngModel #userCsvSpy="ngModel" [ngModelOptions]="{'standalone': true}">
                <label for="user-csv">Choose file...</label>
            </div>
            <div class="mt-2">
                <a class="file-anchor template-download" type="button" href="assets/csv/bulk-deletion-users.csv" download>Download Template</a>
                <p class="mb-0">
                    <span class="mdi mdi-information text-muted"></span>
                    <span class="small text-muted ms-1">File Upload Limit: {{bulkUserDeletionCsvLimit ?? '100'}}</span>
                </p>
                <p class="mb-0">
                    <span class="mdi mdi-information text-muted"></span>
                    <span class="small text-muted ms-1">Only emails with @increff.com will be considered valid</span>
                </p>
                <p class="mb-0">
                    <span class="mdi mdi-information text-muted"></span>
                    <span class="small text-muted ms-1">Users will be deleted across all applications</span>
                </p>
            </div>
        </div>
        <div class="col-12" *ngIf="bulkDeletionCsvErrors?.length">
            <div class="mt-2 mb-0 alert alert-danger">
                <h5 class="fw-light">File Errors</h5>
                <p class="mb-0" *ngFor="let field of bulkDeletionCsvErrors">{{field?.error}}</p>
            </div>
        </div>
    </div>
    <div class="modal-footer" modal-footer-content>
        <button type="button" appButton class="btn btn-sm btn-danger me-2" (click)="uploadUserDeletionFileSetup(userCsvSpy, cancelBtnSpy)">
            <span>Submit</span>
        </button>
        <button type="button" appButton class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal" (click)="bulkDeletionCsvErrors = [];" #cancelBtnSpy>
            <span>Cancel</span>
        </button>
    </div>
</com-modal>

<com-modal [config]="enableUserStateModalConfig">
    <div class="text-center">
        Are you sure you want to
        <span class="fw-bold">ENABLE</span>
        this user?
    </div>
</com-modal>

<com-modal [config]="disableUserStateModalConfig">
    <div class="text-center">
        Are you sure you want to
        <span class="fw-bold">DISABLE</span>
        this user?
    </div>
</com-modal>

<com-modal [config]="enableUserVerificationStatusModalConfig">
    <div class="text-center">
        Are you sure you want to
        <span class="fw-bold">ENABLE</span>
        Email Verification for this user?
    </div>
</com-modal>

<com-modal [config]="disableUserVerificationStatusModalConfig">
    <div class="text-center">
        Are you sure you want to
        <span class="fw-bold">DISABLE</span>
        Email Verification for this user?
    </div>
</com-modal>

<com-modal [config]="enabledUserMFAStatusModalConfig">
    <div class="text-center">
        Are you sure you want to
        <span class="fw-bold">ENABLE</span>
        MFA for this user?
    </div>
</com-modal>

<com-modal [config]="disableUserMFAStatusModalConfig">
    <div class="text-center">
        Are you sure you want to
        <span class="fw-bold">DISABLE</span>
        MFA for this user?
    </div>
</com-modal>

<com-modal [config]="updateUserDetailsModalConfig" #updateUserDetailsModal>
    <com-form [formFields]="updateUserDetailsFormFields"></com-form>
</com-modal>

<com-modal [config]="manageUserLoginModeModalConfig" #updateUserDetailsModal>
    <form>
        <div class="row">
            <div class="px-3 py-2 col-12 col-md-6 form-group form-label-group">
                <select class="form-control form-select" name="authMode" id="authMode" ngModel [ngModelOptions]="{standalone: true}" required [disabled]="!loginModes?.length" #manageLoginModeSelectSpy (ngModelChange)="manageUserLoginModeFormFields = fieldsService?.getFormFields(manageLoginModeSelectSpy?.value === 'basic' ? manageUserLoginModeFormModel : {});">
                    <option disabled value="" selected>Choose Login Mode</option>
                    <option *ngFor="let mode of loginModes" [value]="mode?.value" [disabled]="mode?.value === 'system'">{{mode?.key}}</option>
                </select>
                <label for="authMode" class="required">Login Mode</label>
            </div>
        </div>

    </form>
    <com-form [formFields]="manageUserLoginModeFormFields || {}" #manageUserLoginModeForm></com-form>
    <div class="mx-2 mt-1 text-muted small" *ngIf="manageLoginModeSelectSpy?.value === 'basic' || manageLoginModeSelectSpy?.value === 'system'">
        Password should be 10-character long alphanumeric and must contain at least one of ! @ # $ & special characters
    </div>
    <div class="modal-footer" modal-footer-content>
        <button type="button" appButton class="btn btn-sm btn-accent me-2" (click)="updateUserLoginMode(manageLoginModeSelectSpy, manageUserLoginModeForm?.formObjSpy, loginModeCancelBtnSpy)" [disabled]="!manageLoginModeSelectSpy?.value || manageUserLoginModeForm?.formObjSpy?.invalid">
            <span>Submit</span>
        </button>
        <button type="button" appButton class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal" (click)="manageLoginModeSelectSpy.value = '';" #loginModeCancelBtnSpy>
            <span>Cancel</span>
        </button>
    </div>
</com-modal>

<com-modal [config]="changeUserPasswordModalConfig">
    <com-form [formFields]="changeUserPasswordFormFields"></com-form>
    <div class="mx-2 mt-1 text-muted small">
        Password should be 10-character long alphanumeric and must contain at least one of ! @ # $ & special characters
    </div>
</com-modal>

<com-modal [config]="resetUserModalConfig">
    <div class="text-center">
        Are you sure that you want to reset this user?
      <!-- <span class="fw-bold">{{selectedUser?.fullName}}</span> ? -->
    </div>
</com-modal>


<com-role-management [selectedUser]="selectedUser" [appName]="appName" [flow]="flow" [domainId]="domainId" (updatedUserDetailsEmitter)="updateUserDetailsEmitterHandler($event)"></com-role-management>

<com-sidedrawer [config]="domainSettingsModalConfig">
    <ng-container *ngIf="flow === 'domain'">
        <ul class="nav nav-tabs mt-n1">
            <li class="nav-item"><a class="nav-link pointer fw-light" [ngClass]="{'active': activeTab === 'config'}" data-bs-toggle="tab" data-bs-target="#config" (click)="activeTab = 'config';">Configurations</a></li>
            <li class="nav-item"><a class="nav-link pointer fw-light" [ngClass]="{'active': activeTab === 'migration'}" data-bs-toggle="tab" data-bs-target="#migration" (click)="activeTab = 'migration';">Migration</a></li>
        </ul>
    </ng-container>
      <div class="px-2 py-3 tab-content" id="pills-tabContent">
        <div class="tab-pane fade" id="config" [ngClass]="{'show active': activeTab === 'config' || flow === 'admin'}">
            <form #domainSettingsForm="ngForm">
                <div class="mb-3 row">
                    <div class="mb-3 col-12">
                        <label class="me-3">Email Verification</label>
                        <label class="my-auto switch ms-n2" for="user-email-verification-for-domain">
                            <input type="checkbox" name="verificationRequired" id="user-email-verification-for-domain" [(ngModel)]="!!domainSettingsDummy.verificationRequired" title="Turn {{domainSettingsDummy?.verificationRequired ? 'Off' : 'On'}}" data-bs-placement="right" (change)="domainSettingsDummy.mfaVerificationRequired = !domainSettingsDummy?.verificationRequired ? domainSettingsDummy?.verificationRequired : !!domainSettingsDummy?.mfaVerificationRequired; initTooltip();" #domainLevelEmailVerificationSwitchSpy />
                            <span class="ball"></span>
                          </label>
                          <p class="mt-2 mb-0 small text-muted">
                            <span class="mdi mdi-alert-circle me-1"></span>
                            <span class="fw-light">Turning On this option will immediately logout all non-verified users signed-in via username/email and password.</span>
                          </p>
                    </div>
                    <div class="py-1 mb-3 col-12" [ngClass]="{'disabled-setting': !domainSettingsDummy?.verificationRequired}">
                        <label class="me-3">Multi Factor Authentication</label>
                        <label class="my-auto switch ms-n2" for="user-mfa-verification-for-domain">
                            <input type="checkbox" name="mfaVerificationRequired" id="user-mfa-verification-for-domain" [disabled]="!domainSettingsDummy.verificationRequired" [(ngModel)]="!!domainSettingsDummy.mfaVerificationRequired" title="Turn {{domainSettingsDummy?.mfaVerificationRequired ? 'Off' : 'On'}}" data-bs-placement="right" (change)="initTooltip();" #domainLevelMFAVerificationSwitchSpy />
                            <span class="ball"></span>
                          </label>
                          <p class="mt-2 mb-0 small text-muted">
                            <span class="mdi mdi-alert-circle me-1"></span>
                            <span class="fw-light">Email Verification needs to be turned on to toggle MFA status.</span>
                          </p>
                          <p class="mt-2 mb-0 small text-muted">
                            <span class="mdi mdi-alert-circle me-1"></span>
                            <span class="fw-light">Turning On this option will enable MFA for all users that opted to sign-in via username and password.</span>
                          </p>
                    </div>
                    <div class="mb-3 col-12 form-label-group">
                        <input type="text" inputmode="numeric" class="form-control" placeholder="Enter Logout Threshold" name="userLogoutDaysThreshold" id="user-logout-days-threshold" rangeValidate="1,{{MAX_LOGOUT_DAYS}}" [disableDecimalParsing]="true" (input)="domainSettingsIntervention(domainSettingsForm?.controls, logoutDaysSpy?.value)" (keyup.enter)="focusElem(disableDaysSpy);" [(ngModel)]="domainSettingsDummy.userLogoutDaysThreshold" required #logoutDaysSpy="ngModel" />
                        <label for="user-logout-days-threshold" class="required">User Logout Threshold (Days)</label>
                        <control-messages [control]="logoutDaysSpy?.control"></control-messages>
                        <p class="mt-2 mb-1 small text-muted fw-light" [ngClass]="{'mt-3': logoutDaysSpy?.control?.invalid && logoutDaysSpy?.control?.dirty}">
                            <span class="mdi mdi-information me-1"></span>
                            <span>Session will remain active for this many number of days.</span>
                        </p>
                        <p class="mt-1 mb-0 small text-muted fw-light">
                            <span class="mdi mdi-information me-1"></span>
                            <span>This Setting will take effect after the session expires or logout.</span>
                        </p>
                    </div>
                    <div class="mt-2 mb-3 col-12 form-label-group">
                        <input type="text" inputmode="numeric" class="form-control" placeholder="Enter Disable Threshold" name="userDisableDaysThreshold" id="user-disable-days-threshold" rangeValidate="{{makeNumber(logoutDaysSpy?.value) + 1 ?? 1}},{{MAX_DISABLE_DAYS}}" [disableDecimalParsing]="true" (keyup.enter)="openConfirmationModalBtn?.click();" [(ngModel)]="domainSettingsDummy.userDisableDaysThreshold" required #disableDaysSpy="ngModel" />
                        <label for="user-disable-days-threshold" class="required">User Disable Threshold (Days)</label>
                        <control-messages [control]="disableDaysSpy?.control"></control-messages>
                        <p class="mt-1 mb-0 small text-muted fw-light" [ngClass]="{'mt-3': disableDaysSpy?.control?.invalid && disableDaysSpy?.control?.dirty}">
                            <span class="mdi mdi-information me-1"></span>
                            <span>User will be disabled due to inactivity after this many number of days post last session expiration or logout.</span>
                        </p>
                    </div>
                    <div class="col-12 form-label-group">
                        <textarea class="form-control" name="allowedDomain" id="user-email-verifiication-allowed-domains" placeholder="For example increff.com" [(ngModel)]="domainSettingsDummy.allowedDomain" #allowedDomainsSpy></textarea>
                        <label for="user-email-verifiication-allowed-domains">Allowed Domains</label>
                        <!-- <control-messages [control]="allowedDomainsSpy?.control"></control-messages> -->
                        <p class="mt-2 mb-0 small text-muted">
                            <span class="mdi mdi-information me-1"></span>
                            <span class="fw-light">Login and addition of users via username/email and password will be allowed for the mentioned domains.</span>
                          </p>
                        <p class="mt-2 mb-0 small text-muted">
                            <span class="mdi mdi-alert-circle me-1"></span>
                            <span class="fw-light">Comma separated values are recognized. Empty means all domains.</span>
                        </p>
                    </div>
                </div>
            </form>
            <div class="mt-3 modal-footer" modal-footer-content>
                <button type="button" class="btn btn-sm btn-primary me-2" data-bs-toggle="modal" data-bs-target="#domain-settings-confirmation-modal" [disabled]="domainSettingsForm?.invalid" #openConfirmationModalBtn appButton>Submit</button>
                <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="offcanvas" (click)="domainSettingsForm?.reset();" #closeDomainSettingsOffcanvasBtn appButton>Cancel</button>
            </div>
        </div>
        <ng-container *ngIf="flow === 'domain'">
            <div class="tab-pane fade" id="bulk" [ngClass]="{'show active': activeTab === 'migration'}" >
                <div class="row">
                    <div class="mb-3 col-12">
                        <button type="button" class="btn btn-sm btn-primary" title="Download User Verification Status Report" data-bs-placement="right" (click)="getUserVerificationReport();">
                            <span class="mdi mdi-cloud-download me-1"></span>
                            <span>Download Report</span>
                        </button>
                    </div>
                    <div class="col-12">
                        <!-- <h6 class="fw-light">User Migration</h6> -->
                        <label class="fw-semibold required">CSV File</label>
                        <div class="mb-2 custom-file">
                            <input type="file" accept=".csv" class="form-control" name="userMigrationCsv" id="user-migration-csv-input" ngModel required [ngModelOptions]="{standalone: true}" #userMigrationCsvSpy="ngModel"/>
                            <label for="user-migration-csv-input">Choose file...</label>
                        </div>
                        <a class="template-download" href="assets/csv/user-migration.csv" download>Download Template</a>
                        <span class="mdi mdi-help-circle-outline text-primary-dark ms-2" role="button" data-bs-toggle="popover" data-bs-trigger="click" data-bs-placement="bottom" data-bs-content-id="user-migration-popover-content"></span>
                        <div id="user-migration-popover-content" class="d-none"><com-template-info [templateFields]="userMigrationTemplateGuide"></com-template-info></div>
                    </div>
                </div>
                <div class="mt-4 modal-footer" modal-footer-content>
                    <button type="button" class="btn btn-sm btn-primary me-2" (click)="uploadUserVerificationFile(userMigrationCsvSpy, closeMigrationOffcanvasBtnRef)" appButton>Submit</button>
                    <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="offcanvas" (click)="domainSettingsDummy = {}; activeTab = 'migration';" #closeMigrationOffcanvasBtnRef appButton>Cancel</button>
                </div>
            </div>
        </ng-container>
      </div>
</com-sidedrawer>

<com-modal [config]="domainSettingsConfirmationModalConfig">
    <div class="text-center">
        <p class="mb-2">Are you sure that you want to set the following values?</p>
        <p class="mb-1 h6">
            <span class="fw-light">Logout Days: </span>
            <span>{{domainSettingsForm?.value?.userLogoutDaysThreshold}}</span>
        </p>
        <p class="mb-1 h6">
            <span class="fw-light">Disable Days: </span>
            <span>{{domainSettingsForm?.value?.userDisableDaysThreshold}}</span>
        </p>
        <p class="mb-0 h6">
            <span class="fw-light">Email Verification Required : </span>
            <span class="text-uppercase">{{!!domainSettingsForm?.value?.verificationRequired}}</span>
        </p>
        <p class="mb-0 h6">
            <span class="fw-light">Multi Factor Authentication Required : </span>
            <span class="text-uppercase">{{!!domainSettingsForm?.value?.mfaVerificationRequired}}</span>
        </p>
        <p class="mb-0 h6">
            <span class="fw-light">Allowed Domains : </span>
            <span>{{domainSettingsForm?.value?.allowedDomain || "ALL"}}</span>
        </p>
    </div>
    <div class="w-100 d-flex justify-content-between modal-footer" modal-footer-content>
        <button type="button" appButton class="btn btn-sm btn-success me-2" (click)="updateDomainSettings(domainSettingsForm, closeBtnSpy, closeOffCanvasBtnSpy)">
        Confirm
        </button>
        <button type="button" appButton class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal">
        Cancel
        </button>
        <button type="button" appButton class="btn btn-sm d-none" data-bs-toggle="offcanvas" data-bs-target="#domain-settings-modal" #closeOffCanvasBtnSpy></button>
        <button type="button" appButton class="btn btn-sm d-none" data-bs-dismiss="modal" #closeBtnSpy></button>
    </div>
</com-modal>

<com-modal [config]="bulkAddUsersRolesModalConfig">
    <div class="row">
        <div class="col-12">
            <p class="small text-muted">
                <span class="mdi mdi-information-outline me-1"></span>
                <span>Role and resource based access can be added through csv upload.</span>
            </p>
        </div>
        <div class="col-12">
            <label class="fw-semibold required">CSV File</label>
            <div class="mb-2 custom-file">
                <input type="file" accept=".csv" class="form-control" name="bulkUpdateUsersCsv" id="bulk-update-users-roles-csv" ngModel required [ngModelOptions]="{standalone: true}" #bulkUpdateUserRolesCsvSpy="ngModel"/>
                <label for="bulk-update-users-roles-csv">Choose file...</label>
            </div>
            <a class="template-download" href="assets/csv/bulk-add-users-roles.csv" download>Download Template</a>
            <span class="mdi mdi-help-circle-outline text-primary-dark ms-2" role="button" data-bs-toggle="popover" data-bs-trigger="click" data-bs-placement="bottom" data-bs-content-id="bulk-update-popover-content"></span>
            <div id="bulk-update-popover-content" class="d-none"><com-template-info [templateFields]="bulkUpdateUsersTemplateGuide"></com-template-info></div>
        </div>
    </div>
    <div class="mt-4 modal-footer" modal-footer-content>
        <button type="button" class="btn btn-sm btn-primary me-2" (click)="bulkAddUserRoles(bulkUpdateUserRolesCsvSpy, bulkUpdateUsersModalCloseBtn)" appButton>Submit</button>
        <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal" #bulkUpdateUsersModalCloseBtn (click)="bulkUpdateUserRolesCsvSpy?.reset();" appButton>Cancel</button>
    </div>
</com-modal>

<com-modal [config]="bulkAddUsersModalConfig">
    <div class="row">
        <div class="col-12">
            <label class="fw-semibold required">CSV File</label>
            <div class="mb-2 custom-file">
                <input type="file" accept=".csv" class="form-control" name="bulkAddUsersCsv" id="bulk-add-users-roles-csv" ngModel required [ngModelOptions]="{standalone: true}" #bulkAddUsersCsvSpy="ngModel"/>
                <label for="bulk-add-users-roles-csv">Choose file...</label>
            </div>
            <a class="template-download" href="assets/csv/bulk-add-users.csv" download>Download Template</a>
            <span class="mdi mdi-help-circle-outline text-primary-dark ms-2" role="button" data-bs-toggle="popover" data-bs-trigger="click" data-bs-placement="bottom" data-bs-content-id="bulk-add-users-popover-content"></span>
            <div id="bulk-add-users-popover-content" class="d-none"><com-template-info [templateFields]="bulkAddUsersTemplateGuide"></com-template-info></div>
            <p class="mb-0 small text-muted">Max Row Limit: 5000</p>
        </div>
    </div>
    <div class="mt-4 modal-footer" modal-footer-content>
        <button type="button" class="btn btn-sm btn-success me-2" (click)="bulkAddUsers(bulkAddUsersCsvSpy, bulkAddUsersModalCloseBtn)" appButton>Submit</button>
        <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal" #bulkAddUsersModalCloseBtn (click)="bulkAddUsersCsvSpy?.reset();" appButton>Cancel</button>
    </div>
</com-modal>